import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MapboxClient from 'mapbox';
import {WebMercatorViewport} from 'viewport-mercator-project';

import Fade from '@material-ui/core/Fade';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Localization from '../../Localization';

class Geocoder extends Component {
  debounceTimeout = null;
  state = {
    results: [],
    showResults: false,
    inputValue: ''
  };

  static getDerivedStateFromProps(nextProps, state) {
    if (state.inputValue.length === 0 && nextProps.initialInputValue !== '') {
      return {
        inputValue: nextProps.initialInputValue
      };
    }

    return null;
  }

  onChange = (event) => {
    const {timeout, queryParams, localGeocoder, limit, localOnly} = this.props;
    const queryString = event.target.value;

    this.setState({
      inputValue: event.target.value
    });

    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      const localResults = localGeocoder ? localGeocoder(queryString) : [];
      const params = {...queryParams, ...{limit: limit - localResults.length}};

      if (params.limit > 0 && !localOnly && queryString.length > 0) {
        this.client.geocodeForward(queryString, params).then((res) => {
          this.setState({
            results: [...localResults, ...res.entity.features]
          });
        });
      } else {
      this.setState({
          results: localResults
      });
      }
    }, timeout);
  };
  onSelected = (item) => {
    const {viewport, onSelected, transitionDuration, hideOnSelect, pointZoom, formatItem, updateInputOnSelect} = this.props;
    let newViewport = new WebMercatorViewport(viewport);
    const {bbox, center} = item;

    if (bbox) {
        newViewport = newViewport.fitBounds([
            [bbox[0], bbox[1]],
            [bbox[2], bbox[3]]
        ]);
    } else {
        newViewport = {
            longitude: center[0],
            latitude: center[1],
            zoom: pointZoom
        };
    }

    const {longitude, latitude, zoom} = newViewport;

    onSelected({...viewport, ...{longitude, latitude, zoom, transitionDuration}}, item);

    if (hideOnSelect) {
        // this.setState({results: []});
    }

    if (updateInputOnSelect) {
        this.setState({inputValue: formatItem(item)});
    }
  };

  showResults = () => {
      this.setState({showResults: true});
  };

  hideResults = () => {
      setTimeout(() => {
          this.setState({showResults: false});
      }, 300);
  };

  constructor(props) {
      super();

      this.client = new MapboxClient(props.mapboxApiAccessToken);
  }

  render() {
      const {results, showResults, inputValue} = this.state;
      const {formatItem, className, inputComponent, itemComponent} = this.props;

      const Input = inputComponent || 'input';
      const Item = itemComponent || 'div';

      return (
          <div style={{position:"relative"}}>
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <SearchIcon style={{paddingBottom:"25px"}}/>
                </Grid>
                <Grid item >
                  <TextField id="input-with-icon-grid" label={Localization.strings.KEYWORD}
                    style={{bottom:"13px"}}
                    margin="normal"
                    size="small"
                    variant="outlined"
                    onChange={this.onChange} onBlur={this.hideResults} onFocus={this.showResults} value={inputValue}
                  />
                </Grid>
              </Grid>

              <Fade in={showResults && !!results.length}>
                <div style={{position:"absolute", zIndex:1, display: "flex", backgroundColor:"white"}}>
                  <List component="nav" aria-label="mailbox folders">
                    {results.map((item, index) => (
                        <ListItem key={index} button dense>
                          <ListItemText primary={formatItem(item)} 
                            onClick={() => this.onSelected(item)}
                          />
                        </ListItem>
                    ))}
                  </List>
                </div>
              </Fade>
          </div>
      );
  }
}

Geocoder.propTypes = {
    timeout: PropTypes.number,
    queryParams: PropTypes.object,
    viewport: PropTypes.object.isRequired,
    onSelected: PropTypes.func.isRequired,
    transitionDuration: PropTypes.number,
    hideOnSelect: PropTypes.bool,
    pointZoom: PropTypes.number,
    mapboxApiAccessToken: PropTypes.string.isRequired,
    formatItem: PropTypes.func,
    className: PropTypes.string,
    inputComponent: PropTypes.func,
    itemComponent: PropTypes.func,
    limit: PropTypes.number,
    localGeocoder: PropTypes.func,
    localOnly: PropTypes.bool,
    updateInputOnSelect: PropTypes.bool,
    initialInputValue: PropTypes.string
};

Geocoder.defaultProps = {
    timeout: 300,
    transitionDuration: 0,
    hideOnSelect: false,
    updateInputOnSelect: false,
    pointZoom: 16,
    formatItem: item => item.place_name,
    queryParams: {},
    className: '',
    limit: 10,
    initialInputValue: ''
};

export default Geocoder;